import axios from 'axios';

const { EXTERNAL_API, EXTERNAL_API_TOKEN } = window.uniteus;

const externalApiAxios = axios.create({
  baseURL: EXTERNAL_API,
  headers: {
    Authorization: `Bearer ${EXTERNAL_API_TOKEN}`,
  },
});

export default externalApiAxios;
